export const friendLinks = [{
  name: '同花顺官网',
  link: 'https://www.10jqka.com.cn/'
}, {
  name: '同花顺AI生态平台',
  link: 'https://aimiai.com/?src=thsyun'
}, {
  name: '同花顺i问财',
  link: 'https://www.iwencai.com/'
}, {
  name: '同花顺iFinD',
  link: 'https://ft.10jqka.com.cn/index.php?c=index&a=home'
}];
export const companyInfo = {
  copyRight: '@浙江同花顺智能科技有限公司版权所有',
  ICP: '浙ICP备18026790号',
  filingNo: '浙公安备33011002011820号',
  customerService: '0571-88911818（接通后请转接B2B-8207）',
  email: 'b2b_yunying@myhexin.com'
};